import { useMediaQuery } from '@mui/material'
import useDeviceDetect from './useDeviceDetect'
import { useViewModeOverride } from './useViewModeOverride'

/**
 * Tablets (768px and above) should show desktop interface.
 */
const DESKTOP_MIN_WIDTH = '768px'

export default function useIsMobile(minWidth: string = DESKTOP_MIN_WIDTH) {
  // Check for view mode override (user preference to force desktop view)
  const { forceDesktop } = useViewModeOverride()

  const { isMobile } = useDeviceDetect()
  const hasMobileWidth = !useMediaQuery(`screen and (min-width: ${minWidth})`)

  // When toggle is ON (forceDesktop = true), user wants mobile view
  // When toggle is OFF (forceDesktop = false), use normal detection (defaults to desktop for tablets)
  if (forceDesktop) {
    return true // Force mobile view
  }

  // Only show mobile interface if device is detected as a phone AND has mobile width
  // Tablets are excluded from useDeviceDetect, so they won't be treated as mobile
  if (!isMobile) return false
  return isMobile || hasMobileWidth
}

export const useIsDesktop = () => !useIsMobile()
